// react and mui stuff
import { ChangeEvent, ReactNode } from "react";

import Box from "@mui/joy/Box"
import Typography from "@mui/joy/Typography"
import Radio, { RadioProps } from "@mui/joy/Radio"
import RadioGroup from "@mui/joy/RadioGroup"


type props = {
  label?: string,
  children: ReactNode
  value: any
  setValue: any
}

export default function ExclusiveButtons(props: props) {
  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
      {props.label && <Typography sx={{ fontWeight: 'lg', fontSize: 'sm' }}>
        {props.label}
      </Typography>}
      <RadioGroup
        orientation="horizontal"
        aria-labelledby="segmented-controls-example"
        name="justify"
        value={props.value}
        onChange={(event: ChangeEvent<HTMLInputElement>) =>
          props.setValue(event.target.value)
        }
        sx={{
          minHeight: 48,
          padding: '4px',
          borderRadius: '12px',
          bgcolor: 'neutral.softBg',
          '--RadioGroup-gap': '4px',
          '--Radio-actionRadius': '8px',
        }}
      >
        {props.children}
      </RadioGroup>
    </Box>
  );
}

export function RadioButton (props: RadioProps & { selected: any }) {
  return (
    <Radio
      color="neutral"
      disableIcon
      variant={ props.selected === props.value ? "solid": "outlined" }
      sx={{ px: 2, alignItems: 'center' }}
      {...props}
    >
      {props.children}
    </Radio>
  )
}